(function () {
  const header = document.getElementById('header-component');
  if (!header) return;

  const PEEK_ZONE = 80;
  const SCROLL_THRESHOLD = 40;

  let mouseAtTop = false;
  let ticking = false;

  function update() {
    const sy = window.scrollY;
    if (sy < SCROLL_THRESHOLD) {
      header.classList.add('bhc-at-top');
      header.classList.remove('bhc-scrolled');
      header.classList.remove('bhc-nav-hidden');
    } else {
      header.classList.remove('bhc-at-top');
      header.classList.add('bhc-scrolled');
      if (mouseAtTop) {
        header.classList.remove('bhc-nav-hidden');
      } else {
        header.classList.add('bhc-nav-hidden');
      }
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  document.addEventListener('mousemove', function (e) {
    const wasAtTop = mouseAtTop;
    mouseAtTop = e.clientY < PEEK_ZONE;
    if (mouseAtTop !== wasAtTop) update();
  });

  document.addEventListener('mouseleave', function () {
    mouseAtTop = false;
    update();
  });

  update();
})();
